/** Public addresses live under the app's own host: /{academy}/{course}. */
export function publicHost(): string {
  return window.location.host;
}

export function academyUrl(academySlug: string): string {
  return `${window.location.origin}/${academySlug}`;
}

export function courseUrl(academySlug: string, courseSlug: string): string {
  return `${window.location.origin}/${academySlug}/${courseSlug}`;
}

/** URL without the protocol, as shown on chips: «zerno.pages.dev/shopiforge». */
export function displayUrl(url: string): string {
  return url.replace(/^https?:\/\//, '');
}

export const adminPaths = {
  root: '/admin',
  newAcademy: '/admin/academies/new',
  academy: (academyId: string) => `/admin/a/${academyId}`,
  newCourse: (academyId: string) => `/admin/a/${academyId}?new=course`,
  course: (academyId: string, courseId: string) => `/admin/a/${academyId}/courses/${courseId}`,
  courseStudents: (academyId: string, courseId: string) => `/admin/a/${academyId}/courses/${courseId}?tab=students`,
  lesson: (academyId: string, courseId: string, lessonId: string) => `/admin/a/${academyId}/courses/${courseId}/lessons/${lessonId}`,
  /** The lesson as students see it, from the author's account. */
  lessonPreview: (academyId: string, courseId: string, lessonId: string) => `/admin/a/${academyId}/courses/${courseId}/lessons/${lessonId}/preview`,
  newLesson: (academyId: string, courseId: string, sectionId?: string | null) =>
    `/admin/a/${academyId}/courses/${courseId}/lessons/new${sectionId ? `?section=${sectionId}` : ''}`,
  students: (academyId: string) => `/admin/a/${academyId}/students`,
  promos: (academyId: string) => `/admin/a/${academyId}/promos`,
  marketing: (academyId: string) => `/admin/a/${academyId}/marketing`,
  funnel: (academyId: string) => `/admin/a/${academyId}/funnel`,
  support: (academyId: string) => `/admin/a/${academyId}/support`,
  team: (academyId: string) => `/admin/a/${academyId}/team`,
  /** ChatGPT, Claude and other agents connected over MCP; the author's, not an academy's. */
  agents: '/admin/agents',
};

/** The invitation link from a team email. */
export const joinPath = (token: string) => `/join?token=${encodeURIComponent(token)}`;

export const platformPaths = {
  root: '/admin/platform',
  authors: '/admin/platform/authors',
  academies: '/admin/platform/academies',
  students: '/admin/platform/students',
  plans: '/admin/platform/plans',
};

export const studentPaths = {
  landing: (academy: string, course: string) => `/${academy}/${course}`,
  course: (academy: string, course: string) => `/${academy}/${course}/learn`,
  lesson: (academy: string, course: string, lessonId: string) => `/${academy}/${course}/learn/${lessonId}`,
};
